import * as React from 'react';
import {useSelector} from 'react-redux';

import {Assignables} from 'nutshell-core/assignables';
import {safelyGetFilterByKey} from 'nutshell-core/filter';
import {Stagesets} from 'nutshell-core/stagesets';
import type {FilterObject} from 'nutshell-core/types';

import {convertToModels} from 'shells/filter-capsule/convert-to-models';
import {FilterCapsule} from 'shells/filter-capsule/filter-capsule';

import {appHistory} from '../../../history';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {TASK_REPORT_SCHEMA} from '../report-constants';

type Props = {
    filters: FilterObject[];
    onFilterSubmit: (filterObj: FilterObject) => void;
    onFilterRemove: (filterKey: string) => void;
};

export function TaskReportFilters(props: Props) {
    const assignables = useSelector(Assignables.getAllUsers);
    const pipelines = useSelector(Stagesets.getFilterableStagesets);
    const {user} = useGetSessionUser();

    const pipelineFooterButton =
        user && user.permissions.canAccessSetup
            ? {
                  label: 'Manage pipelines',
                  onClick: () => {
                      appHistory.push('/sales/pipelines');
                  },
              }
            : undefined;

    return (
        <>
            <FilterCapsule
                size='big'
                // @ts-expect-error
                collection={convertToModels(pipelines)}
                filter={safelyGetFilterByKey(props.filters, 'stageset')}
                filterName='stageset'
                // @ts-expect-error
                schemaField={TASK_REPORT_SCHEMA.stageset}
                onSubmit={props.onFilterSubmit}
                onUpdate={props.onFilterSubmit}
                onRemove={props.onFilterRemove}
                footerButton={pipelineFooterButton}
            />
            <FilterCapsule
                size='big'
                collection={convertToModels(assignables)}
                filter={safelyGetFilterByKey(props.filters, 'assignee')}
                filterName='assignee'
                // @ts-expect-error
                schemaField={TASK_REPORT_SCHEMA.assignee}
                onSubmit={props.onFilterSubmit}
                onUpdate={props.onFilterSubmit}
                onRemove={props.onFilterRemove}
            />
        </>
    );
}
